import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Container, Table, Form, Pagination } from 'react-bootstrap';
import Sidebar from './Sidebar';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_URL from "../config/api";

const AdminPinStatus = () => {
    const [pinData, setPinData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const itemsPerPage = 50;
    const [error, setError] = useState();

    useEffect(() => {
        fetchPins();
    }, []);

    const fetchPins = async () => {
        try {

            const response = await fetch(`${API_URL}/treepins/get_pins.php`);

            const data = await response.json();

            setPinData(Array.isArray(data) ? data : []);

        } catch (err) {

            console.error(err);
            setError("Unable to load pins.");

        }
    };

    const handleVerify = async (treeInstanceId, verified) => {
        try{
            const response = await fetch(`${API_URL}/treepins/verify_pin.php`,
                {
                    method:"POST",
                    headers:{
                        "Content-Type":"application/json"
                    },
                    body:JSON.stringify({
                        treeinstanceid:treeInstanceId,
                        pinverified:verified ? 1 : 0
                    })
                }
            );

            const result = await response.json();

            if(result.success){
                toast.success("Pin verified successfully.");
                fetchPins();
            }else{
                toast.error(result.message);
            }
        }catch(err){
            console.error(err);
            toast.error("Server error.");
        }
    };

    const handleStatusUpdate = async (treeInstanceId, status) => {
        try {
            const response = await fetch(`${API_URL}/treepins/update_pin_status.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        treeinstanceid: treeInstanceId,
                        status: status
                    })
                }
            );
            const result = await response.json();
            if (result.success) {
                toast.success("Plant status updated.");
                fetchPins();
            } else {
                toast.error(result.message);
            }
        } catch (err) {
            console.error(err);
            toast.error("Server Error");
        }
    };


    const filteredData = Array.isArray(pinData)
        ? pinData.filter((details) => {
            const searchTermRegex = new RegExp(searchTerm, "i");

            return (
                searchTermRegex.test(String(details.speciesid)) ||
                searchTermRegex.test(details.plantername || "") ||
                searchTermRegex.test(details.status || "") ||
                searchTermRegex.test(String(details.pinverified))
            );
        })
    : [];


    const lastIndex = currentPage * itemsPerPage;
    const firstIndex = lastIndex - itemsPerPage;
    const currentData = filteredData.slice(firstIndex, lastIndex);

    const totalPageCount = Math.ceil(filteredData.length / itemsPerPage);

    return (
        <div className="App">
            <Sidebar />
            
                <section className='userlist-section'>
                    <div className="container"><br /><br /><br />
                        <h2 className='overview13'>Pins:</h2>
                        <div className="row justify-content-start">
                            <div className="col" id='qrtable'>
                                <Form.Group controlId="search">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </Form.Group>
                                <div className="table-responsive">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Species ID</th>
                                                <th className="d-none d-md-table-cell">latitude</th>
                                                <th className="d-none d-md-table-cell">Longitude</th>
                                                <th className="d-none d-md-table-cell">Planter Name</th>
                                                <th className="d-none d-md-table-cell">Date Pinned</th>
                                                <th className="d-none d-md-table-cell">Status</th>
                                                <th className="d-none d-md-table-cell">Verification</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentData.map((data) => (
                                                <tr key={data.treeinstanceid}>
                                                    <td>{data.treeinstanceid}</td>
                                                    <td>{data.speciesid}</td>
                                                    <td className="d-none d-md-table-cell">{data.latitude}</td>
                                                    <td className="d-none d-md-table-cell ">{data.longitude}</td>
                                                    <td className="d-none d-md-table-cell ">{data.plantername}</td>
                                                    <td className="d-none d-md-table-cell ">{data.dateadded}</td>
                                                    <td className="d-none d-md-table-cell ">{data.status}</td>
                                                    <td className="d-none d-md-table-cell ">{data.pinverified ? "Verified" : "Not Verified"}</td>
                                                    <td>
                                                        <button
                                                            onClick={() => handleVerify(data.treeinstanceid, true)}
                                                            disabled={data.pinverified}
                                                            style={{ marginBottom: "5px", width: "100%" }}
                                                        >
                                                            {data.pinverified ? "Verified" : "Verify"}
                                                        </button>

                                                        <Form.Select
                                                            value={data.status}
                                                            onChange={(e) =>
                                                                handleStatusUpdate(
                                                                    data.treeinstanceid,
                                                                    e.target.value
                                                                )
                                                            }
                                                        >
                                                            <option value="Growing">Growing</option>
                                                            <option value="Flowering">Flowering</option>
                                                            <option value="Fruiting">Fruiting</option>
                                                            <option value="Matured">Matured</option>
                                                            <option value="Died">Died</option>
                                                        </Form.Select>

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>


                                <div style={{ display: 'flex', justifyContent: 'center', color: 'black' }}>
                                    <Pagination>
                                        {Array.from({ length: totalPageCount}, (_, index) => (
                                            <Pagination.Item
                                                key={index + 1}
                                                active={index + 1 === currentPage}
                                                onClick={() => setCurrentPage(index + 1)}
                                            >
                                                {index + 1}
                                            </Pagination.Item>
                                        ))}
                                    </Pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            {error && <p className="error">{error}</p>}
            {/* ToastContainer for displaying Toast notifications */}
            <ToastContainer position="top-center" autoClose={2000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </div>
    );
};

export default AdminPinStatus;
